/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Page Reports Constructor component
 *
 * @author Evgeniy Naumov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import styled from 'styled-components';

import { colors, fonts } from '@theme/index';

export const ConstructorStyled = styled.div`
    position: relative;
    margin-bottom: 88px;
`;

export const ConstructorListStyled = styled.ul`
    padding: 0;
    display: grid;
    grid-gap: 24px;
    list-style: none;
`;

export const ConstructorRowStyled = styled.ul`
    width: 100%;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 24px;
    list-style: none;
`;

export const TableConstructorScheduleContainerStyled = styled.li`
    grid-column: 1 / -1;
    margin-top: 24px;

    &.schedule-container-enter {
        margin-top: 0;
        opacity: 0;
    }

    &.schedule-container-enter-active {
        margin-top: 24px;
        opacity: 0.5;
        transition-property: all;
        transition-duration: 500ms;
        transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
    }

    &.schedule-container-exit {
        opacity: 0.5;
    }

    &.schedule-container-exit-active {
        opacity: 0;
        margin-top: 0;
        transition-property: all;
        transition-duration: 500ms;
        transition-timing-function: cubic-bezier(0.64, 0, 0.78, 0);
    }
`;

interface IConstructorCardStyled {
    selected?: boolean;
}

export const ConstructorCardStyled = styled.li<IConstructorCardStyled>`
    position: relative;
    padding: 24px 24px 10px;
    min-height: 112px;
    border: 1px solid transparent;
    border-radius: 4px;
    box-shadow: ${(props) => !props.selected && '0 0px 8px 0 rgba(0, 0, 0, 0.2)'};
    cursor: ${(props) => (props.selected ? 'default' : 'pointer')};

    &:hover {
        border-color: ${(props) => !props.selected && colors.constructorCardBorderHover};
    }

    border-color: ${(props) => props.selected && colors.constructorCardBorderActive};
`;

export const ConstructorCardContainerStyled = styled.div`
    max-width: 85%;
`;

export const ConstrucotorCardTitleStyled = styled.h4`
    margin: 0 0 4px 0;
`;

export const ConstrucotorCardSubtitleStyled = styled.p`
    margin: 0;
    color: ${colors.constructorBasketSelected};
    font-size: 12px;
    opacity: 0.6;
`;

export const ConstrucotorCardDescriptionStyled = styled.p`
    margin: 8px 0 16px;
`;

export const ConstructorCardImageStyled = styled.img`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
    width: 50px;
    height: 50px;
`;

export const ConstrucotorMenuContainerStyled = styled.div`
    position: absolute;
    cursor: pointer;
    right: 24px;
    top: 24px;

    li {
        font-family: ${fonts.textMain};
    }
`;

export const ConstructorCardButton = styled.button`
    font-family: ${fonts.textMain};
    position: relative;
    border: none;
    background: transparent;
    padding: 0;
    margin-top: 8px;
    display: flex;
    align-items: center;
    color: ${colors.constructorCardButton};
    cursor: pointer;

    img {
        margin-right: 4px;
        margin-left: -3px;
    }

    &:after {
        display: none;
        position: absolute;
        bottom: -1px;
        left: 0;
        content: "";
        width: 100%;
        height: 1px;
        background-color: ${colors.constructorCardButton};
    }
    &:hover {
        ::after {
            display: block;
        }
    }
`;
